import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress
} from '@mui/material';

const DeleteConfirmationDialog = ({ isOpen, onClose, onConfirm, itemName, isLoading = false }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={isLoading ? undefined : onClose} // Prevent closing during loading
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { borderRadius: '12px' , padding: 3} }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: '#dc3545', fontSize: 22, fontWeight: 'bold' }}>
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete {itemName}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          disabled={isLoading}
          color="inherit"
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          disabled={isLoading}
          color="error"
          variant="contained"
          startIcon={isLoading ? <CircularProgress size={16} sx={{ color: 'white' }} /> : null}
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;